/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_ViewInputs */

const en_projects_view = /** @type {(inputs: Projects_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View project`)
};

const lv_projects_view = /** @type {(inputs: Projects_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt darbu`)
};

/**
* | output |
* | --- |
* | "View project" |
*
* @param {Projects_ViewInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_view = /** @type {((inputs?: Projects_ViewInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_ViewInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_view(inputs)
	return en_projects_view(inputs)
});